(function () {
  'use strict';

  const BASIC = new Set(Array.from('@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà'));
  const EXTENDED = new Set(Array.from('\f^{}\\[~]|€'));
  // Plain stand-ins that keep the meaning. Letters such as á, ę or ł are never
  // swapped: they belong to the language even though they need Unicode.
  const PUNCTUATION = {
    '‘': "'", '’': "'", '‚': "'", '‛': "'", '′': "'", '´': "'", '`': "'",
    '“': '"', '”': '"', '„': '"', '‟': '"', '″': '"',
    '‐': '-', '‑': '-', '‒': '-', '–': '-', '—': '-', '―': '-', '−': '-', '…': '...'
  };
  // Anything that forces Unicode while showing as a blank needs a name on the
  // page. A soft hyphen used to read "The character  makes this message use
  // Unicode." next to an empty badge, with its code only in a hover tooltip.
  const NAMES = {
    '\t': 'tab', '\n': 'line break', '\r': 'carriage return', '\f': 'page break', '\v': 'vertical tab',
    '\u00a0': 'no-break space', '\u00ad': 'soft hyphen', '\u034f': 'grapheme joiner', '\u061c': 'Arabic letter mark',
    '\u115f': 'Hangul filler', '\u1160': 'Hangul filler', '\u1680': 'Ogham space', '\u180e': 'Mongolian vowel separator',
    '\u2000': 'en quad space', '\u2001': 'em quad space', '\u2002': 'en space', '\u2003': 'em space',
    '\u2004': 'third-em space', '\u2005': 'quarter-em space', '\u2006': 'sixth-em space', '\u2007': 'figure space',
    '\u2008': 'punctuation space', '\u2009': 'thin space', '\u200a': 'hair space', '\u200b': 'zero-width space',
    '\u200c': 'zero-width non-joiner', '\u200d': 'zero-width joiner', '\u200e': 'left-to-right mark', '\u200f': 'right-to-left mark',
    '\u2028': 'line separator', '\u2029': 'paragraph separator', '\u202a': 'left-to-right embedding', '\u202b': 'right-to-left embedding',
    '\u202c': 'direction reset', '\u202d': 'left-to-right override', '\u202e': 'right-to-left override', '\u202f': 'narrow no-break space',
    '\u205f': 'medium math space', '\u2060': 'word joiner', '\u2061': 'invisible function sign', '\u2062': 'invisible times sign',
    '\u2063': 'invisible separator', '\u2064': 'invisible plus sign', '\u2066': 'left-to-right isolate', '\u2067': 'right-to-left isolate',
    '\u2068': 'first-strong isolate', '\u2069': 'isolate end', '\u3000': 'wide space', '\u3164': 'Hangul filler',
    '\ufe0e': 'text style selector', '\ufe0f': 'emoji style selector', '\ufeff': 'byte order mark', '\uffa0': 'Hangul filler',
    '‘': 'curly quote', '’': 'curly apostrophe', '‚': 'low quote', '‛': 'reversed quote', '“': 'curly quote', '”': 'curly quote',
    '„': 'low quote', '‟': 'reversed quote', '′': 'prime', '″': 'double prime', '´': 'accent mark', '`': 'backtick',
    '‐': 'Unicode hyphen', '‑': 'no-break hyphen', '‒': 'figure dash', '–': 'en dash', '—': 'em dash', '―': 'horizontal bar',
    '−': 'minus sign', '…': 'ellipsis'
  };
  const SPACE_LIKE = /^[\t\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000]$/;
  const LINE_LIKE = /^[\v\u2028\u2029]$/;
  // Line-break hints, file markers and control codes carry no meaning in a text.
  const STRAY = /^[\u0000-\u0008\u000e-\u001f\u007f-\u009f\u00ad\u200b\u2060-\u2064\ufeff]$/;
  const unicodePattern = (source, fallback) => {
    try { return new RegExp(source, 'u'); } catch (_) { return fallback; }
  };
  // Joiners, direction marks and style selectors shape Arabic, Hebrew and Indic
  // writing, so the clean-up drops them only when everything around is basic.
  const INVISIBLE = unicodePattern('^[\\p{Cc}\\p{Cf}\\p{Zl}\\p{Zp}\\p{Default_Ignorable_Code_Point}]$', /^[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u180e\u200b-\u200f\u202a-\u202e\u2060-\u206f\ufe00-\ufe0f\ufeff]$/);
  const EMOJI = unicodePattern('\\p{Emoji_Presentation}|\\p{Extended_Pictographic}\\ufe0f|\\p{Regional_Indicator}|\\u20e3|\\p{Emoji_Modifier}', /[\ud83c-\ud83e][\udc00-\udfff]|[\u2600-\u27bf]\ufe0f/);
  const MARK = unicodePattern('^\\p{M}$', /^[\u0300-\u036f]$/);
  const LETTER = unicodePattern('^[\\p{L}\\p{M}\\p{N}]$', /^[^\s!-/:-@[-`{-~\u2000-\u2bff]$/);
  // {first_name} or {{ first_name }}: texting apps swap these for each person's
  // details before sending, so their braces never reach the phone.
  const MERGE_TAG = /\{\{[^{}]*\}\}|\{\s*[A-Za-z_][\w.-]*\s*\}/g;
  const characterSegmenter = typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function'
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' }) : null;
  // One curly apostrophe turns this 141-character reminder into 3 text parts,
  // and the one-click fix brings it back to 1. The old 105-character sample
  // fitted in one part and showed nothing the counter can do.
  const SAMPLES = {
    cart: 'Everyday Edit: We’re holding the Everyday Tote in your cart for 24 more hours. Finish checkout here: example.com/cart. Reply STOP to opt out.'
  };
  const LONG_TEXT = 320;
  // Twilio documents 1,600 characters as the most one message body can hold.
  const TWILIO_BODY_LIMIT = 1600;

  const isBasic = char => BASIC.has(char) || EXTENDED.has(char);
  const isEmoji = part => EMOJI.test(part);
  const number = value => value.toLocaleString('en-US');
  const plural = (count, one, many = `${one}s`) => `${number(count)} ${count === 1 ? one : many}`;
  const partWord = count => (count === 1 ? 'text part' : 'text parts');
  const codeLabel = text => Array.from(text).map(char => `U+${char.codePointAt(0).toString(16).toUpperCase().padStart(4, '0')}`).join(' ');
  const joinWords = words => (words.length < 2 ? words.join('') : `${words.slice(0, -1).join(', ')} and ${words[words.length - 1]}`);
  // Only our own words start a sentence in lower case; "é" must not become "É".
  const capitalize = text => (/^[a-z]/.test(text) ? text.charAt(0).toUpperCase() + text.slice(1) : text);
  const article = name => (/^(?:[aeio]|u(?!ni))/i.test(name) ? `an ${name}` : `a ${name}`);
  // ’ and ' look almost the same in most fonts, so fixes name what they change.
  const TARGET_WORDS = { "'": "straight '", '"': 'straight "', '-': 'hyphen -', '...': 'three dots ...' };
  const sourceWord = char => (NAMES[char] || char).replace(/ (?:apostrophe|quote)$/, '');

  function graphemes(text) {
    return characterSegmenter ? Array.from(characterSegmenter.segment(text), part => part.segment) : Array.from(text);
  }

  function countCharacters(text) {
    return graphemes(text).length;
  }

  function unitWeights(characters, gsm) {
    return characters.map(char => gsm ? (EXTENDED.has(char) ? 2 : 1) : char.length);
  }

  function segmentSMS(text, sender = 'standard') {
    if (typeof text !== 'string') throw new TypeError('Message must be a string');
    const characters = Array.from(text);
    const unicodeCharacters = [...new Set(characters.filter(char => !isBasic(char)))];
    const gsm = unicodeCharacters.length === 0;
    const weights = unitWeights(characters, gsm);
    const units = weights.reduce((sum, count) => sum + count, 0);
    const singleLimit = gsm ? 160 : 70;
    const multipartLimit = gsm ? (sender === 'toll-free' ? 152 : 153) : (sender === 'toll-free' ? 66 : 67);
    const capacity = units <= singleLimit ? singleLimit : multipartLimit;
    const pieces = [];
    let current = { text: '', units: 0 };
    characters.forEach((char, index) => {
      // Keep an extension escape sequence or UTF-16 surrogate pair in one segment.
      if (current.units + weights[index] > capacity) {
        pieces.push(current);
        current = { text: '', units: 0 };
      }
      current.text += char;
      current.units += weights[index];
    });
    if (current.units) pieces.push(current);
    return {
      encoding: gsm ? 'GSM-7' : 'Unicode', gsm, units, characters: countCharacters(text),
      segments: pieces.length, singleLimit, multipartLimit, capacity, pieces,
      remaining: units ? capacity - current.units : singleLimit,
      unicodeCharacters, extensionCharacters: [...new Set(characters.filter(char => EXTENDED.has(char)))]
    };
  }

  function packedParts(weights, singleLimit, multipartLimit) {
    const units = weights.reduce((sum, count) => sum + count, 0);
    if (!units) return 0;
    if (units <= singleLimit) return 1;
    let parts = 1;
    let fill = 0;
    weights.forEach(weight => {
      if (fill + weight > multipartLimit) { parts++; fill = 0; }
      fill += weight;
    });
    return parts;
  }

  function trimmedWeights(weights, units) {
    const kept = weights.slice();
    let left = units;
    for (let index = kept.length - 1; index >= 0 && left > 0; index--) {
      if (kept[index] === 1) { kept.splice(index, 1); left--; }
    }
    while (left > 0 && kept.length) left -= kept.pop();
    return kept;
  }

  // The fewest one-unit characters (letters, spaces) to cut so the text needs
  // one part fewer. A 307-character text used to read "You can add 152 more"
  // when one character stood between it and 2 parts.
  function unitsToDropPart(text, sender = 'standard') {
    const result = segmentSMS(text, sender);
    if (result.segments < 2) return 0;
    const target = result.segments - 1;
    let cut = Math.max(1, result.units - (target === 1 ? result.singleLimit : target * result.multipartLimit));
    if (target === 1) return cut;
    // A two-unit character never splits across parts, so a full part can end
    // one unit short. Check the number by trimming plain characters from the end.
    const weights = unitWeights(Array.from(text), result.gsm);
    while (cut < result.units && packedParts(trimmedWeights(weights, cut), result.singleLimit, result.multipartLimit) > target) cut++;
    return cut;
  }

  function plainEdits(text) {
    const changes = new Map();
    const note = (from, to) => { if (!changes.has(from)) changes.set(from, to); };
    const parts = graphemes(text).map(part => {
      if (isEmoji(part)) return part;
      const composed = part.normalize('NFC');
      // "é" typed as e plus a separate accent needs Unicode; joined up it is basic.
      if (composed !== part && Array.from(composed).every(isBasic)) { note(part, composed); return composed; }
      return Array.from(part).map(char => {
        if (isBasic(char)) return char;
        const plain = PUNCTUATION[char] || (SPACE_LIKE.test(char) ? ' ' : LINE_LIKE.test(char) ? '\n' : STRAY.test(char) ? '' : char);
        if (plain !== char) note(char, plain);
        return plain;
      }).join('');
    });
    const basicAround = parts.every(part => isEmoji(part) || Array.from(part).every(char => isBasic(char) || INVISIBLE.test(char)));
    const plain = parts.map(part => (isEmoji(part) || !basicAround ? part : Array.from(part).filter(char => {
      if (isBasic(char) || !INVISIBLE.test(char)) return true;
      note(char, '');
      return false;
    }).join(''))).join('');
    return { text: plain, changes };
  }

  function cleanPunctuation(text) {
    return plainEdits(text).text;
  }

  function removeEmoji(text) {
    let code = 0xe000;
    while (text.includes(String.fromCharCode(code))) code++;
    const mark = String.fromCharCode(code);
    const marked = graphemes(text).map(part => (isEmoji(part) ? mark : part)).join('');
    if (!marked.includes(mark)) return text;
    // Take one neighbouring space with each run of emoji: "waiting 👜 Take" → "waiting Take".
    return marked.replace(new RegExp(`[ \\t]*${mark}(?:[ \\t]*${mark})*[ \\t]*`, 'g'), (run, at, whole) => {
      const before = whole[at - 1];
      const after = whole[at + run.length];
      const between = before !== undefined && after !== undefined && !/[\n([{]/.test(before) && !/[\n.,!?;:)\]}]/.test(after);
      return between && /[ \t]/.test(run) ? ' ' : '';
    });
  }

  function mergeTags(text) {
    const pattern = new RegExp(MERGE_TAG.source, 'g');
    const tags = [];
    let match;
    while ((match = pattern.exec(text))) tags.push({ text: match[0], start: match.index, end: match.index + match[0].length });
    return tags;
  }

  function describe(char, units) {
    const invisible = SPACE_LIKE.test(char) || LINE_LIKE.test(char) || INVISIBLE.test(char);
    const kind = PUNCTUATION[char] ? 'punctuation' : EXTENDED.has(char) ? 'symbol' : invisible ? 'invisible' : LETTER.test(char) ? 'letter' : 'symbol';
    return { kind, units, invisible, name: NAMES[char] || (invisible ? 'invisible character' : '') };
  }

  // One entry per character as typed (🇺🇸, not two boxed letters), with its
  // unit cost, a name for anything that shows as a blank, and how often it
  // appears. Basic text lists only its two-unit symbols.
  function specialCharacters(text, sender = 'standard') {
    const result = segmentSMS(text, sender);
    const tags = mergeTags(text);
    const found = new Map();
    const add = (key, details) => {
      const entry = found.get(key);
      if (entry) entry.count++;
      else found.set(key, Object.assign({ text: key, count: 1, code: codeLabel(key) }, details));
    };
    let offset = 0;
    graphemes(text).forEach(part => {
      const at = offset;
      offset += part.length;
      const characters = Array.from(part);
      if (result.gsm) {
        // The braces in {first_name} are swapped out before sending.
        if (tags.some(tag => at >= tag.start && at < tag.end)) return;
        characters.filter(char => EXTENDED.has(char)).forEach(char => add(char, describe(char, 2)));
        return;
      }
      if (characters.every(isBasic)) return;
      if (isEmoji(part)) return add(part, { kind: 'emoji', units: part.length, invisible: false, name: '' });
      const composed = part.normalize('NFC');
      if (composed !== part && Array.from(composed).every(isBasic)) {
        return add(part, { kind: 'accent', units: part.length, invisible: false, name: characters.length > 1 ? 'accent typed separately' : `look-alike ${composed}` });
      }
      // A letter with a visible accent mark is one letter; a style selector is not a mark to show.
      if (characters.length > 1 && characters.every(char => isBasic(char) || (MARK.test(char) && !INVISIBLE.test(char)))) {
        return add(part, { kind: 'letter', units: part.length, invisible: false, name: '' });
      }
      characters.filter(char => !isBasic(char)).forEach(char => add(char, describe(char, char.length)));
    });
    return Array.from(found.values());
  }

  function plainPieces(changes) {
    const replaced = new Map();
    const spaces = [];
    const lines = [];
    const removed = [];
    const joined = [];
    changes.forEach((to, from) => {
      if (to === '') removed.push(from);
      else if (to === ' ') spaces.push(from);
      else if (to === '\n') lines.push(from);
      else if (PUNCTUATION[from] === to) replaced.set(to, (replaced.get(to) || []).concat(from));
      else joined.push(to);
    });
    const name = char => NAMES[char] || 'invisible character';
    const pieces = [];
    replaced.forEach((from, to) => {
      // "curly ’ with straight '": grouped by kind, with the glyphs as typed.
      const kinds = new Map();
      from.forEach(char => kinds.set(sourceWord(char), (kinds.get(sourceWord(char)) || []).concat(char)));
      const typed = joinWords(Array.from(kinds, ([word, chars]) => `${word} ${chars.join(' ')}`));
      pieces.push({ verb: 'replace', label: `${typed} with ${TARGET_WORDS[to] || to}`, short: `the ${typed}` });
    });
    if (spaces.length) {
      pieces.push(spaces.length === 1
        ? { verb: 'replace', label: `${name(spaces[0])} with a space`, short: `the ${name(spaces[0])}` }
        : { verb: 'replace', label: 'unusual spaces with plain ones', short: 'the unusual spaces' });
    }
    if (lines.length) pieces.push({ verb: 'replace', label: `${lines.length === 1 ? name(lines[0]) : 'unusual line breaks'} with a line break`, short: lines.length === 1 ? `the ${name(lines[0])}` : 'the unusual line breaks' });
    if (joined.length) pieces.push({ verb: 'join', label: `the accent in ${joined.join(' ')}`, short: `the accent in ${joined.join(' ')}` });
    if (removed.length) {
      pieces.push(removed.length <= 2
        ? { verb: 'remove', label: removed.map(name).join(' and '), short: removed.length === 1 ? `the ${name(removed[0])}` : `the ${removed.map(name).join(' and ')}` }
        : { verb: 'remove', label: `${removed.length} invisible characters`, short: `${removed.length} invisible characters` });
    }
    return pieces;
  }

  const PAST = { replace: 'replaced', remove: 'removed', join: 'joined' };

  function describeFix(option) {
    const pieces = [];
    if (option.kind !== 'plain') {
      const list = option.emoji.length <= 3 ? joinWords(option.emoji) : `${option.emoji.length} emoji`;
      pieces.push({ verb: 'remove', label: list, short: list });
    }
    if (option.kind !== 'emoji') pieces.push(...plainPieces(option.changes));
    const groups = [];
    pieces.forEach(piece => {
      const group = groups.find(item => item.verb === piece.verb);
      if (group) group.pieces.push(piece);
      else groups.push({ verb: piece.verb, pieces: [piece] });
    });
    const phrase = (tense, key) => groups.map(group => `${tense === 'past' ? PAST[group.verb] : group.verb} ${joinWords(group.pieces.map(piece => piece[key]))}`).join(' and ');
    const { before, after } = option;
    const effect = after.segments < before.segments
      ? `${before.segments} → ${plural(after.segments, 'text part')}`
      : after.gsm && !before.gsm
        ? `Back to basic text: room for ${plural(after.remaining, 'more character')} instead of ${number(before.remaining)}`
        : `Room for ${plural(before.units - after.units, 'more character')}`;
    return Object.assign({}, option, {
      label: capitalize(phrase('present', 'label')),
      past: capitalize(phrase('past', 'label')),
      phrase: phrase('present', 'short'),
      effect
    });
  }

  // One-click changes are offered only when they save a part, bring the text
  // back to basic text or free up room. "Use plain quotes and dashes" used to
  // be offered even when it turned 2 parts into 3.
  function fixOptions(text, sender = 'standard', maxLength = Infinity) {
    const before = segmentSMS(text, sender);
    if (!before.units) return [];
    const plain = plainEdits(text);
    const withoutEmoji = removeEmoji(text);
    const emoji = [...new Set(graphemes(text).filter(isEmoji))];
    const make = (kind, value, changes) => {
      if (value === text || value.length > maxLength || !value.trim()) return null;
      return { kind, text: value, before, after: segmentSMS(value, sender), changes, emoji };
    };
    const plainFix = make('plain', plain.text, plain.changes);
    const emojiFix = make('emoji', withoutEmoji, new Map());
    const bothFix = plain.text !== text && withoutEmoji !== text ? make('both', removeEmoji(plain.text), plain.changes) : null;
    const saves = option => Boolean(option) && option.after.segments < before.segments;
    const helps = option => Boolean(option) && option.after.segments <= before.segments
      && (saves(option) || (option.after.gsm && !before.gsm) || option.after.units < before.units);
    const offered = [helps(plainFix) && plainFix, saves(emojiFix) && emojiFix].filter(Boolean);
    const best = offered.reduce((low, option) => Math.min(low, option.after.segments), before.segments);
    if (saves(bothFix) && bothFix.after.segments < best) return [describeFix(bothFix)];
    return offered.sort((a, b) => a.after.segments - b.after.segments).map(describeFix);
  }

  function recipientSegments(segments, value) {
    if (!Number.isSafeInteger(segments) || segments < 0) return null;
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^\d+$/.test(value.trim()))) return null;
    const count = Number(value);
    if (!Number.isInteger(count) || count < 1 || count > 1000000) return null;
    const total = segments * count;
    return Number.isSafeInteger(total) ? total : null;
  }

  function characterLabel(char) {
    const { name } = describe(char, 1);
    return `${name || char} · ${codeLabel(char)}`;
  }

  function init(root) {
    if (!root || root.dataset.smsReady) return;
    const find = name => root.querySelector(`[data-sms-${name}]`);
    const input = find('message');
    if (!input) return;
    root.dataset.smsReady = 'true';
    const sender = find('sender');
    const recipients = find('recipients');
    const messageLimit = input.maxLength > 0 ? input.maxLength : 2000;
    let undoState = null;
    let announcementTimer;
    let usageReported = false;
    let fixes = [];
    // After the counter rewrites the text, copying it back is the next step.
    let copyNext = false;
    const set = (name, value) => { const node = find(name); if (node) node.textContent = value; };
    const hide = (name, hidden) => { const node = find(name); if (node) node.hidden = hidden; };
    const on = (name, event, callback) => { const node = find(name); if (node) node.addEventListener(event, callback); };
    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const senderType = () => {
      if (!sender) return 'standard';
      const checked = sender.querySelector('input:checked');
      return checked ? checked.value : sender.value || 'standard';
    };
    // Focusing the box on a phone raises the keyboard over the counts the
    // action just changed.
    const coarsePointer = () => typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;

    function toolEvent(name) {
      document.dispatchEvent(new CustomEvent('myuser:tool-event', { detail: { name } }));
    }

    function markUsed() {
      if (usageReported) return;
      usageReported = true;
      toolEvent('sms_calculator_used');
    }

    function focusMessage(start = input.value.length, end = start) {
      if (coarsePointer()) {
        // Keep keyboard users in place when the button they pressed disappears.
        const active = document.activeElement;
        const undo = find('undo');
        if (active && active !== document.body && (active.hidden || active.disabled || active.closest('[hidden]')) && undo && !undo.hidden) undo.focus({ preventScroll: true });
        return;
      }
      input.focus({ preventScroll: true });
      input.setSelectionRange(start, end);
    }

    function tokenWord(token) {
      if (token.invisible) return article(token.name);
      if (token.kind === 'punctuation') return `${article(token.name)} (${token.text})`;
      return token.name ? `${token.text} (${token.name})` : token.text;
    }

    function renderLead(result, cut) {
      const lead = find('guidance');
      if (!lead) return;
      if (!result.units) { lead.replaceChildren(); return; }
      if (result.segments === 1) {
        lead.replaceChildren(element('strong', '', 'Fits in 1 text part'), result.remaining
          ? `, with room for ${plural(result.remaining, 'more character')}.` : ', with no room to spare.');
        return;
      }
      // A text made only of heavy emoji has too few plain characters to cut.
      const light = graphemes(input.value).filter(part => unitWeights(Array.from(part), result.gsm).reduce((sum, weight) => sum + weight, 0) === 1).length;
      lead.replaceChildren(element('strong', '', `Cut ${plural(cut, light >= cut ? 'character' : 'unit')}`), ` to send it as ${plural(result.segments - 1, 'text part')}.`);
      const basic = !result.gsm && fixes.find(fix => fix.after.gsm && fix.after.segments < result.segments);
      if (basic) lead.append(` Or ${basic.phrase} to use basic text: `, element('strong', '', plural(basic.after.segments, 'text part')), '.');
    }

    function reason(result, tokens) {
      if (!result.units || !tokens.length) return '';
      if (result.gsm) {
        const words = tokens.slice(0, 3).map(tokenWord);
        return `${capitalize(joinWords(words))} ${tokens.length === 1 ? 'counts as 2 units' : 'count as 2 units each'} in basic text.`;
      }
      const letters = tokens.filter(token => token.kind === 'letter');
      const others = tokens.filter(token => token.kind !== 'letter');
      const words = others.slice(0, 3).map(tokenWord);
      if (others.length > 3) words.push(plural(others.length - 3, 'more character'));
      if (letters.length) words.push(`letters like ${joinWords(letters.slice(0, 2).map(token => token.text))}`);
      const single = tokens.length === 1 && !letters.length;
      const standardMultipart = segmentSMS('', senderType()).multipartLimit;
      const room = result.segments > 1
        ? `each part holds ${result.multipartLimit} units instead of ${standardMultipart}`
        : `one part holds ${result.singleLimit} units instead of 160`;
      let sentence = `${capitalize(joinWords(words))} ${single ? 'switches' : 'switch'} the whole text to Unicode, so ${room}.`;
      const heavy = tokens.filter(token => token.units > 1).sort((a, b) => b.units - a.units).slice(0, 2);
      if (heavy.length && result.units !== result.characters) {
        sentence += ` Limits count units, not characters: ${joinWords(heavy.map((token, index) => `${token.text} is ${index ? token.units : plural(token.units, 'unit')}`))}.`;
      }
      if (letters.length && !others.length) sentence += ' Keep letters your readers need.';
      return sentence;
    }

    function renderSpecials(tokens) {
      const box = find('special-chars');
      if (!box) return;
      box.replaceChildren();
      tokens.slice(0, 12).forEach(token => {
        const chip = element('span', token.invisible ? 'sms-char is-invisible' : 'sms-char');
        chip.append(element('b', '', token.invisible ? token.name : token.text));
        const meta = [];
        if (!token.invisible && token.name) meta.push(token.name);
        if (token.invisible) meta.push(token.code);
        if (token.units > 1 || token.kind === 'emoji') meta.push(plural(token.units, 'unit'));
        if (token.count > 1) meta.push(`×${number(token.count)}`);
        // The space is not drawn between flex items but keeps "🇺🇸 4 units" apart for screen readers.
        if (meta.length) chip.append(' ', element('small', '', meta.join(' · ')));
        chip.title = token.code;
        box.appendChild(chip);
      });
      if (tokens.length > 12) box.appendChild(element('span', 'sms-char is-more', `+ ${plural(tokens.length - 12, 'more character')}`));
    }

    function renderFixes() {
      ['suggestion', 'second-fix'].forEach((name, index) => {
        const button = find(name);
        if (!button) return;
        const fix = fixes[index];
        button.hidden = !fix;
        button.dataset.fix = fix ? fix.kind : '';
        button.classList.toggle('is-primary', index === 0);
        if (fix) {
          button.replaceChildren(element('span', '', fix.label), element('small', '', fix.effect));
          button.setAttribute('aria-label', `${fix.label}: ${fix.effect}`);
        } else {
          button.replaceChildren();
          button.removeAttribute('aria-label');
        }
      });
      hide('fixes', !fixes.length);
    }

    function visibleText(text) {
      return text.replace(/\r\n|\n|\r/g, ' ↵ ').replace(/\t/g, ' ⇥ ');
    }

    // The split side is shown exactly ("Reply STO"); the side that is shortened
    // with "…" backs off to a whole word.
    function excerpt(text, showStart, showEnd) {
      const parts = graphemes(text);
      const cut = count => {
        const space = parts.slice(0, count).lastIndexOf(' ');
        return visibleText(parts.slice(0, space > count - 14 ? space : count).join(''));
      };
      const tail = count => {
        const start = parts.length - count;
        const space = parts.slice(start, start + 14).indexOf(' ');
        return visibleText(parts.slice(space < 0 ? start : start + space + 1).join(''));
      };
      const nodes = [];
      if (showStart) nodes.push(element('span', 'sms-split', ''));
      if (parts.length <= 46) nodes.push(visibleText(text));
      else if (showStart && showEnd) nodes.push(`${cut(22)} … ${tail(24)}`);
      else if (showEnd) nodes.push(`…${tail(44)}`);
      else nodes.push(`${cut(44)}…`);
      if (showEnd) nodes.push(element('span', 'sms-split', ''));
      nodes.filter(node => typeof node !== 'string').forEach(node => node.setAttribute('aria-hidden', 'true'));
      return nodes;
    }

    // Each part with the text it carries, so "Part 2: P to opt out" shows where
    // the split lands. Long texts fold their full parts into one row instead of
    // twelve identical bars.
    function renderParts(result) {
      const list = find('parts');
      if (!list) return;
      list.replaceChildren();
      list.hidden = result.segments < 2;
      if (result.segments < 2) return;
      const last = result.pieces.length - 1;
      const rows = result.pieces.length > 3 ? [[0, last - 1], [last, last]] : result.pieces.map((_, index) => [index, index]);
      // Read as "Part 1: 153 / 153 units", never "Part 1153".
      const separator = () => element('span', 'sms-visually-hidden', ': ');
      rows.forEach(([from, to]) => {
        const row = element('li', 'sms-part');
        const meta = element('div', 'sms-part-meta');
        const track = element('span', 'sms-part-track');
        track.setAttribute('aria-hidden', 'true');
        track.appendChild(element('i'));
        const text = element('p', 'sms-part-text');
        if (from !== to) {
          meta.append(element('span', 'sms-part-name', `Parts ${from + 1}–${to + 1}`), separator(), element('span', 'sms-part-units', `full, up to ${result.capacity} units each`));
          track.style.setProperty('--sms-fill', '100%');
          text.append(...excerpt(result.pieces[to].text, false, true));
        } else {
          const piece = result.pieces[from];
          meta.append(element('span', 'sms-part-name', `Part ${from + 1}`), separator(), element('span', 'sms-part-units', `${number(piece.units)} / ${result.capacity} units`));
          track.style.setProperty('--sms-fill', `${Math.round(piece.units / result.capacity * 100)}%`);
          text.append(...excerpt(piece.text, from > 0, from < last));
        }
        meta.appendChild(track);
        row.append(meta, text);
        list.appendChild(row);
      });
    }

    function roomLine(result) {
      if (result.segments < 2) return '';
      const boxRoom = messageLimit - input.value.length;
      if (boxRoom <= 0) return `The box is full at ${number(messageLimit)} characters.`;
      if (boxRoom < result.remaining) return `Room for ${plural(boxRoom, 'more character')} before the box is full.`;
      return result.remaining ? `The last part has room for ${plural(result.remaining, 'more character')}.` : 'The last part is full.';
    }

    function tagNote(result) {
      const tags = mergeTags(input.value);
      if (!result.units || !tags.length) return '';
      const distinct = [...new Set(tags.map(tag => tag.text))];
      const nameLike = distinct.every(tag => /name/i.test(tag));
      const base = segmentSMS(input.value.replace(new RegExp(MERGE_TAG.source, 'g'), ''), senderType());
      const parts = Math.max(1, base.segments);
      const room = Math.max(0, Math.floor(((parts === 1 ? base.singleLimit : parts * base.multipartLimit) - base.units) / tags.length));
      const subject = distinct.length === 1 ? `${distinct[0]} is` : `${joinWords(distinct.slice(0, 2))}${distinct.length > 2 ? ' and others' : ''} are`;
      let note = `${subject} filled in for each person, so the count changes from person to person. Here it is counted as typed${result.gsm ? ', and braces count as 2 units each' : ''}. `;
      note += `${nameLike ? 'Names' : 'Filled-in details'} up to ${plural(room, 'character')}${tags.length > 1 ? ' each' : ''} keep it in ${plural(parts, 'text part')}.`;
      if (base.gsm && nameLike) {
        const accented = segmentSMS(input.value.replace(new RegExp(MERGE_TAG.source, 'g'), 'Łukasz'), senderType()).segments;
        note += ` Names with letters like ë or Ł, such as Zoë or Łukasz, switch that person's text to Unicode: with Łukasz it ${accented > parts ? 'needs' : 'still fits in'} ${plural(accented, 'text part')}.`;
      }
      return note;
    }

    function renderWarning(result) {
      const node = find('warning');
      if (!node) return;
      const level = result.characters > TWILIO_BODY_LIMIT ? 'danger' : result.characters > LONG_TEXT ? 'note' : '';
      node.hidden = !level;
      node.dataset.level = level;
      node.textContent = level === 'danger'
        ? `Too long for Twilio: it rejects texts over ${number(TWILIO_BODY_LIMIT)} characters. Split this into shorter texts.`
        : level ? 'Long texts cost more, because each text part is billed.' : '';
    }

    function renderDetails(result, tokens) {
      set('units', number(result.units));
      set('unit-label', result.units === 1 ? 'unit' : 'units');
      set('encoding', result.units ? result.encoding : '—');
      set('capacity-note', !result.units ? '' : result.segments > 1
        ? `Each part of a longer text holds up to ${result.multipartLimit} units. The rest of the part tells the phone how to join them.`
        : `One part holds up to ${result.singleLimit} units in ${result.gsm ? 'basic text' : 'Unicode'}.`);
      set('codes', tokens.length ? `Character codes: ${tokens.slice(0, 12).map(token => `${token.invisible ? token.name : token.text} ${token.code}`).join(' · ')}` : '');
      hide('codes', !tokens.length);
    }

    function renderLimits(result, type) {
      const tollFree = type === 'toll-free';
      set('limits', `${result.gsm ? 'Basic text' : 'Unicode text'} on ${tollFree ? 'a US or Canadian toll-free number' : 'a standard number'}: ${result.singleLimit} units fit in one part; longer texts hold ${result.multipartLimit} per part.`);
      // The reference table follows the chosen number, so it never contradicts the count.
      set('table-gsm-multi', String(segmentSMS('', type).multipartLimit));
      set('table-unicode-multi', String(segmentSMS('á', type).multipartLimit));
      set('table-label', tollFree ? 'per part, toll-free' : 'per part');
      hide('table-note', !tollFree);
      root.dataset.smsNumber = type;
    }

    function update(announce = true) {
      const type = senderType();
      const result = segmentSMS(input.value, type);
      const tokens = specialCharacters(input.value, type);
      fixes = fixOptions(input.value, type, messageLimit);
      const headline = !result.segments ? 'Paste a message to see how many text parts it uses.'
        : result.segments === 1 ? 'Your text fits in 1 text part.'
        : `Your text will be sent in ${result.segments} text parts.`;
      const showUnits = result.units !== result.characters;
      set('segments', number(result.segments));
      set('segment-label', partWord(result.segments));
      set('characters', number(result.characters));
      set('character-label', result.characters === 1 ? 'character' : 'characters');
      set('unit-count', number(result.units));
      set('unit-limit', `/ ${result.singleLimit}`);
      hide('unit-box', !showUnits);
      const unitBox = find('unit-box');
      if (unitBox) unitBox.toggleAttribute('data-over', result.units > result.singleLimit);
      root.dataset.smsUnitView = showUnits ? 'shown' : 'hidden';
      set('headline', headline);
      renderWarning(result);
      renderLead(result, unitsToDropPart(input.value, type));
      set('reason', reason(result, tokens));
      hide('reason', !tokens.length);
      renderSpecials(tokens);
      renderFixes();
      renderParts(result);
      set('remaining', result.units ? roomLine(result) : '');
      const note = tagNote(result);
      set('tag-note', note);
      hide('tag-note', !note);
      hide('feedback', !result.units);
      hide('count-details', !result.units);
      root.dataset.smsMode = result.units ? (result.gsm ? 'gsm' : 'unicode') : 'empty';
      root.dataset.smsPrimary = fixes.length ? 'fix' : copyNext && input.value ? 'copy' : '';
      renderDetails(result, tokens);
      renderLimits(result, type);
      hide('undo', undoState === null);
      for (const action of ['copy', 'clear']) {
        const button = find(action);
        if (button) button.disabled = !input.value;
      }

      const total = recipients && result.segments ? recipientSegments(result.segments, recipients.value) : null;
      if (recipients) {
        const invalid = Boolean(recipients.validity && recipients.validity.badInput) || (recipients.value !== '' && recipientSegments(1, recipients.value) === null);
        hide('recipient-result', total === null);
        hide('recipient-empty', Boolean(result.segments) || invalid);
        hide('recipient-error', !invalid);
        recipients.setAttribute('aria-invalid', String(invalid));
        if (total !== null) {
          const people = Number(recipients.value);
          set('total', `${plural(total, 'text part')} in total`);
          set('total-explainer', `${plural(people, 'person', 'people')} × ${plural(result.segments, 'text part')} each. Names and links can change the count.`);
        }
      }
      clearTimeout(announcementTimer);
      if (announce) {
        announcementTimer = setTimeout(() => {
          const size = showUnits ? `${plural(result.characters, 'character')}, ${plural(result.units, 'unit')}.` : `${plural(result.characters, 'character')}.`;
          set('announcement', result.units ? `${size} ${headline}${total !== null && Number(recipients.value) > 1 ? ` ${plural(total, 'text part')} in total.` : ''}` : headline);
        }, 300);
      }
    }

    function changeText(value, message) {
      if (value.length > messageLimit) {
        set('action-status', 'This change would make the text too long for this box. Shorten it a little first.');
        return false;
      }
      markUsed();
      undoState = { text: input.value, start: input.selectionStart, end: input.selectionEnd };
      input.value = value;
      set('action-status', message);
      update();
      focusMessage();
      return true;
    }

    input.addEventListener('paste', event => {
      if (!event.clipboardData) return;
      // Textareas normalize pasted line endings before applying maxlength.
      const pastedText = event.clipboardData.getData('text/plain').replace(/\r\n?/g, '\n');
      const replacedLength = input.selectionEnd - input.selectionStart;
      if (input.value.length - replacedLength + pastedText.length <= messageLimit) return;
      event.preventDefault();
      set('action-status', 'This paste would make the draft too long for this box. Nothing was pasted. Try a shorter message.');
    });
    input.addEventListener('input', () => {
      markUsed();
      undoState = null;
      copyNext = false;
      let limited = false;
      if (input.value.length > messageLimit) {
        // Keep the limit in UTF-16 units, like maxlength, without cutting an emoji in half.
        input.value = input.value.slice(0, messageLimit).replace(/[\uD800-\uDBFF]$/, '');
        limited = true;
      }
      set('action-status', limited ? `This box holds up to ${number(messageLimit)} characters. Extra text was removed.` : '');
      update();
    });
    on('sender', 'change', () => { markUsed(); update(); });
    on('recipients', 'input', () => { markUsed(); update(); });
    root.querySelectorAll('[data-sms-sample]').forEach(button => {
      button.addEventListener('click', () => {
        const sample = SAMPLES[button.dataset.smsSample];
        if (typeof sample !== 'string') return;
        copyNext = false;
        const parts = segmentSMS(sample, senderType()).segments;
        changeText(sample, `Example added: one curly apostrophe (’) makes it ${plural(parts, 'text part')}. You can edit the words.`);
      });
    });
    on('clear', 'click', () => {
      copyNext = false;
      changeText('', 'Text cleared. Use Undo to bring it back.');
    });
    function applyFix(kind) {
      const fix = fixOptions(input.value, senderType(), messageLimit).find(option => option.kind === kind);
      if (!fix) return;
      const wasNext = copyNext;
      copyNext = true;
      if (!changeText(fix.text, `${fix.past}: ${fix.effect}. Check that the text still says what you mean.`)) copyNext = wasNext;
    }
    ['suggestion', 'second-fix'].forEach(name => on(name, 'click', event => applyFix(event.currentTarget.dataset.fix)));
    on('undo', 'click', () => {
      if (undoState === null) return;
      const previous = undoState;
      input.value = previous.text;
      undoState = null;
      copyNext = false;
      set('action-status', 'Last change undone.');
      update();
      focusMessage(previous.start, previous.end);
    });
    on('copy', 'click', async () => {
      if (!input.value) { set('action-status', 'Paste a message first.'); return; }
      try {
        await navigator.clipboard.writeText(input.value);
        set('action-status', 'Text copied.');
        toolEvent('sms_draft_copied');
        copyNext = false;
        root.dataset.smsPrimary = fixes.length ? 'fix' : '';
      } catch (_) {
        input.focus();
        input.select();
        set('action-status', 'Text selected. Press ⌘C or Ctrl+C to copy.');
      }
    });
    window.addEventListener('pagehide', () => clearTimeout(announcementTimer));
    update(false);
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = {
      segmentSMS, recipientSegments, cleanPunctuation, countCharacters, characterLabel, SAMPLES, init,
      unitsToDropPart, removeEmoji, specialCharacters, mergeTags, fixOptions
    };
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document.querySelector('[data-sms-lab]')), { once: true });
    else init(document.querySelector('[data-sms-lab]'));
  }
})();
